import { render, staticRenderFns } from "./ReleaseDistribution.vue?vue&type=template&id=17fa1bfd&"
import script from "./ReleaseDistribution.vue?vue&type=script&lang=js&"
export * from "./ReleaseDistribution.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseDistribution.vue?vue&type=style&index=0&id=17fa1bfd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports